enum PictureTypes {
  Damage,
  LicensePicture,
  VehicleRegistryPicture,
  VehicleLeftSidePicture,
  VehicleRightSidePicture,
  VehicleFrontPicture,
  VehicleBackPicture,
  VehicleVinPicture,
  VehicleGlassPicture,
  VehiclePlatePicture,
  VehicleMileagePicture,
  VehicleMarbetePicture,
  PoliceRegistryPicture,
  DriverIdPicture,
}

export default PictureTypes;
